module.exports = __webpack_public_path__ + "img/compress_easter_home-top-products_1350x466.da62ecdb.webp";